import React from 'react';

interface NextImageCompatProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  src: string;
  alt: string;
  fill?: boolean;
  priority?: boolean;
}

export default function Image({ fill: _fill, priority: _priority, style, ...props }: NextImageCompatProps) {
  return React.createElement('img', { ...props, style });
}
